<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2023-12-26 11:58:55
!-->
<template>
	<div id="commodities" class="commodities">
		<div class="main-info p24 check-price-form">
			<el-form :model="formData" :rules="allRules" ref="formData" label-position="top" size="medium"
				@submit.native.prevent class="item-Surcharge">
				<div class="new_inquiry_header item-Surcharge_search">
					<el-form-item class="flex-width_1" prop="productName" label="Product Name" label-width="48%">
						<el-input v-model="formData.productName"></el-input>
					</el-form-item>
					<el-form-item class="flex-width_1" prop="skuCode" label="SKU (Optional)" label-width="48%">
						<el-input v-model="formData.skuCode"></el-input>
					</el-form-item>
					<el-form-item class="flex-width_1" prop="description" label="Detailed product description"
						label-width="100%">
						<el-input v-model="formData.description"></el-input>
					</el-form-item>
					<el-form-item class="flex-width_1" prop="endUse" label="End-use of product">
						<el-input v-model="formData.endUse"></el-input>
					</el-form-item>
					<el-form-item class="flex-width_1" prop="countryId" label="Country of manufacture"
						label-width="48%">
						<el-select v-model="formData.countryId" popper-class="cargo_info_select" filterable>
							<el-option v-for="(item, index) in countryList" :key="index" :value="item.id"
								:label="item.code+'-'+item.nameEn"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item class="flex-width_1" prop="url" label="Product URL (Optional)">
						<el-input v-model="formData.url"></el-input>
					</el-form-item>
					<el-form-item class="flex-width_1" prop="HSorHTSCode" label="HS/HTS code (Optional)">
						<el-input v-model="formData.HSorHTSCode"></el-input>
					</el-form-item>
					<el-form-item class="flex-width_1" prop="" label="Supporting documents and image (Optional)">
						Adding additional documents such as product specs, FDA data sheets,
						permits, government agency forms, and photographs will help your
						customs broker classify your product more accurately.
					</el-form-item>
					<el-form-item class="flex-width_1" prop="image" label="">
						<el-upload class="upload"  
						:action="''" 
						:data="{}" 
						ref="upload" 
						:before-upload="handleBeforeUpload" 
						:on-success="(response, file, fileList) => handleSuccess(response, file, fileList, item)" 
						:show-file-list="false" :multiple="false" :limit="1" accept=".jpg,.jpeg,.png,.bmp,.gif">
							<div class="upload-class">
								<img src="../../../assets/img/manage/settings/上传.png" width="24px" height="24px" />
								<div class="upload-label">
									<span>Upload product image</span>
									<span>（File shouldn't exceed 7 MB）</span>
								</div>
								<img src="../../../assets/img/manage/settings/pic_com_pic.png" width="115px"
									height="70px" />
							</div>
              			</el-upload>
					</el-form-item>
					<el-form-item class="flex-width_1" prop="document" label="">
						<div class="upload-class">
							<img src="../../../assets/img/manage/settings/上传.png" width="24px" height="24px" />
							<div class="upload-label">
								<span>Upload your Doc</span>
								<span>（File shouldn't exceed 7 MB）</span>
							</div>
							<img src="../../../assets/img/manage/settings/pic_com_doc.png" width="115px"
								height="70px" />
						</div>
					</el-form-item>
				</div>
			</el-form>
			<div class="foot-button-manage">
				<div>
					<button class="by-common--primary" @click="clickCancel">Cancel</button>
					<button class="by-button--primary" style="margin-left: 24px;" @click="clickSave" :loading="btnLoading">Save</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
	  GetCountry
	} from '../../../api/base.js'
	import request from '@/utils/request'
	import {
		getCookie
	} from '@/utils/cookiejs'
	export default {
		props: {},
		name: "index",
		data() {
			var checkEmpty = (rule, value, callback) => {
				if (rule.required === false) {
					callback();
					return false;
				}
				if (!value) {
					if (rule.fullField == "StartCityKey") {
						this.isCol1 = true;
					} else {
						this.isCol1 = false;
					}

					document.documentElement.scrollTop = 0;
					return callback(new Error("请输入"));
				} else {
					callback();
				}
			};
			return {
				formData: {
					id: "",
					productName: "",
					skuCode: "",
					description: "",
					endUse: "",
					countryId: "459155081518907794",
					url: "",
					HSorHTSCode: "",
					image: {},
					document: [],
				},
				allRules: {
					productName: [{
						required: true,
						validator: checkEmpty,
						trigger: "change",
					}, ],
					description: [{
						required: true,
						validator: checkEmpty,
						trigger: "change",
					}, ],
					endUse: [{
						required: true,
						validator: checkEmpty,
						trigger: "change",
					}, ],
					countryId: [{
						required: true,
						validator: checkEmpty,
						trigger: "change",
					}, ],
				},
				countryList: [],
				token: "",
				visible: false,
				btnLoading: false,
			};
		},
		created() {
			// 实例被创建之后执行代码
			this.token = getCookie('token')
			if (this.token) {
				this.getCountry()
			}
		},
		computed: {
			// 计算属性
		},
		components: {
			// 组件的引用
		},
		methods: {
			// 方法
			//限制文件上传的大小
    		handleBeforeUpload(file) {},
			//上传成功
			handleSuccess(response, file, fileList, item){},
			getCountry() {
				GetCountry().then(res => {
			    this.countryList = res.data
			  })
			},
			init(id) {
				console.log("====校验", id);
				this.formData.id = id || 0;
				this.visible = true;
				this.$nextTick(() => {
					this.$refs['formData'].resetFields();
					if (this.formData.id) {
						request({
							url: '/api/crm/CustomerCommodity/' + this.formData.id,
							method: 'get',
							headers: {
								Authorization: this.token
							},
						}).then(res => {
							this.formData = res.data;
						})
					}
				});
			},
			clickSave() {
				//表单校验
				this.$refs["formData"].validate((val) => {
					if (val) {
						this.btnLoading = true;
						if (!this.formData.id) {
							request({
								url: `/api/crm/CustomerCommodity`,
								method: 'post',
								data: this.formData,
								headers: {
									Authorization: this.token
								},
							}).then((res) => {
								this.$message({
									message: res.msg,
									type: 'success',
									duration: 1000,
									onClose: () => {
										this.btnLoading = false;
										this.clickCancel()
										this.$emit('refresh', true)
									}
								})
							}).finally(() => {
								this.btnLoading = false;
							})
						} else {
							request({
								url: '/api/crm/CustomerCommodity/' + this.formData.id,
								method: 'PUT',
								data: this.formData,
								headers: {
									Authorization: this.token
								},
							}).then((res) => {
								this.$message({
									message: res.msg,
									type: 'success',
									duration: 1000,
									onClose: () => {
										this.btnLoading = false;
										this.clickCancel()
										this.$emit('refresh', true)
									}
								})
							}).finally(() => {
								this.btnLoading = false;
							})
						}
					}
				});
			},
			clickCancel() {
				this.$emit("close", false);
			},
		},
		mounted() {
			// 页面进入时加载内容
		},
		watch: {
			// 监测变化
		},
	};
</script>
<style scoped lang='scss'>
	.commodities {
		height: auto;
		background: #ffffff;
		border-radius: 8px;
		
		.new_inquiry_header {
			width: auto;
			display: flex;
			flex-wrap: wrap;

			.el-form-item--medium:nth-of-type(3),
			.el-form-item--medium:nth-of-type(8) {
				width: 100%;
			}
		}
	}

	.item-Surcharge {
		width: 100%;
		background: #fff;
		border-radius: 8px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;

		.item-Surcharge_search {
			display: flex;
			flex-wrap: wrap;
			width: auto;
			justify-content: space-between;

			.search-flex-item {
				display: flex;
				align-items: baseline;
				margin-right: 16px;
			}

			.search-type {
				width: calc(100% - 65px);

				& ::v-deep .el-input__inner {
					height: 32px !important;
					line-height: 32px !important;
				}

				& ::v-deep .el-select__caret {
					line-height: 32px !important;
				}
			}

			.mr6 {
				margin-right: 6px;
			}

			.search-label {
				width: 80px;
				display: block;
				font-size: 13px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				line-height: 18px;
			}

			.reset-radio-group {
				border-radius: 4px;

				& ::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
					background: rgba(0, 70, 185, 0.04);
					border-color: #0046b9;
					color: #0046b9;
					box-sizing: border-box;
				}

				& ::v-deep .el-radio-button__inner {
					display: inline-block;
					font-size: 14px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #777;

					&:hover {
						color: #0046b9;
					}
				}

				& ::v-deep .el-radio-button--small .el-radio-button__inner {
					padding: 8px 16px;
				}
			}

			.search-left {
				flex: 1;
			}
		}
	}

	.el-select {
		width: 100%;
	}

	.el-form-item--medium {
		width: 48%;
		float: left;
		text-align: left;
		margin-bottom: 0px !important;

		.el-form-item__label {
			line-height: 8px !important;
			padding: 0px 0px 7px 0 !important;
			margin-top: 18px !important;
		}

		.input-Lowest {
			display: flex;

			.el-radio-group {
				width: 120px;
			}

			.el-input__inner {
				width: 60px;
				margin-left: 12px;
			}

			.el-input {
				width: 60px !important;
			}
		}

		.el-radio-group {
			display: flex;
			margin-top: 8px;

			label:nth-of-type(1) {
				margin-right: 20px !important;
			}

			label:nth-of-type(3) {
				margin-left: 10px !important;
			}
		}

		.el-radio__input.is-checked .el-radio__inner {
			border-color: #0046b9;
			background: #0046b9;
		}

		.el-radio__input.is-checked+.el-radio__label {
			color: #0046b9;
		}

		.el-input {
			.el-input__inner {
				border-radius: 4px;
				border: 1px solid #dcdcdc;
				height: 40px;
				line-height: 32px;
				padding-left: 8px;
				font-size: 13px;
				font-family: "PingFangSC-Regular", "Microsoft YaHei", sans-serif;
				font-weight: 500;
				color: #333333;

				&:hover {
					border: 1px solid #999999;
				}

				&:focus {
					border: 1px solid #0046b9;
				}
			}
		}
	}

	.upload-class {
		height: 72px;
		background: rgba(153, 153, 153, 0.06);
		border-radius: 8px;
		border: 1px dashed rgba(153, 153, 153, 0.56);
		display: flex;
		justify-content: space-between;
		align-items: center;
		cursor: pointer;

		.upload-label {
			flex: 1;
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;

			span:nth-of-type(1) {
				color: #333333;
			}

			span:nth-of-type(2) {
				color: #aaaaaa;
			}
		}

		img:nth-of-type(1) {
			margin: 24px 16px 24px 24px;
		}
	}

	.foot-button-manage {
		font-size: 16px;
		margin-top: 33px;

		button {
			width: 160px;
			height: 40px;
		}
	}
</style>